import {atom, useResetRecoilState, useRecoilState} from 'recoil'

// Define atom outside of the hook to prevent recreation on every render
const errorModalAtom = atom({
	key: 'errorModalAtom',
	default: null,
})

const useAlertModalAtom = () => {
	const [state, setState] = useRecoilState(errorModalAtom)
	const resetState = useResetRecoilState(errorModalAtom)

	const setModalEvent = (label) => {
		setState(label)
	}

	return [state, setModalEvent, resetState]
}

export default useAlertModalAtom
